module.exports = __webpack_public_path__ + "static/blue earth-e8780ed21b20107bb74ad7b7b25c5f8d.jpg";